import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-[#F4F1EA] flex items-center justify-center p-6 font-body">
      <div className="w-full max-w-md border border-zinc-200 bg-white p-10 text-center" data-testid="payment-cancel-card">
        <XCircle className="h-14 w-14 mx-auto text-zinc-400" />
        <h1 className="font-display text-3xl font-light mt-6">Checkout canceled</h1>
        <p className="text-zinc-500 text-sm mt-2">No charge was made. You can pick a plan whenever you're ready.</p>
        <Button asChild className="mt-8 bg-[#0B1F33] text-white rounded-none h-11 px-6 hover:bg-zinc-800" data-testid="back-to-billing-button">
          <Link to="/app/billing">Back to billing</Link>
        </Button>
      </div>
    </div>
  );
}
